import { useCallback } from "react";

import { useBaseUrl } from "@/hooks/api";

import { request as requestDefault } from "./request";

export function useRequest() {
  const baseurl = useBaseUrl();

  const request = useCallback(
    <TResponse>(url: string, config: RequestInit = {}) => {
      return requestDefault<TResponse>(`${baseurl}/${url}`, config);
    },
    [baseurl],
  );

  return { request };
}
